import { createApiSlice } from 'app/createApiSlice'
import {
  API_CATCHES,
  API_DELETE_FARMERS,
  API_FARMERS_LIST,
  API_FARMERS_PLOTTING,
  API_FARMERS_REGISTER_V2,
  API_SHARED_GROUP_FARMERS,
  API_SUMMARY_FARMERS,
  API_USER_DETAIL_VESSEL,
} from 'utils/apiList'

export const farmersListApiSlice = createApiSlice.injectEndpoints({
  reducerPath: 'farmersList/api',
  endpoints(builder) {
    return {
      fetchFarmers: builder.query({
        query({ page, status, size = 10, groupCode }) {
          return {
            url: API_FARMERS_LIST,
            params: {
              groupCode,
              page,
              status,
              size,
            },
          }
        },
      }),
      fetchFarmersV2: builder.query({
        query(params) {
          return {
            url: API_FARMERS_REGISTER_V2,
            params: {
              ...params,
            },
          }
        },
      }),
      fetchFarmersDetail: builder.query({
        query(args) {
          const id = typeof args === 'object' ? args?.id : args
          const resourceId =
            typeof args === 'object' ? args?.resourceId : undefined
          if (resourceId) {
            return {
              url: `${API_SHARED_GROUP_FARMERS}/${resourceId}/${id}`,
            }
          }
          return {
            url: `${API_FARMERS_LIST}/${id}`,
          }
        },
        keepUnusedDataFor: 300,
        transformResponse: (res) => {
          if (res?.data && typeof res.data === 'object' && !Array.isArray(res.data)) {
            return res
          }
          return {
            ...res,
            data: res,
          }
        },
      }),
      getInviteAgent: builder.query({
        query({ id }) {
          return {
            url: `api/v1/bussines/invite-agent`,
            params: {
              id,
            },
          }
        },
      }),
      confirmInviteAgent: builder.mutation({
        query({ id, approved }) {
          return {
            url: `api/v1/bussines/group/invite-agent/${id}/confirm`,
            method: 'POST',
            body: {
              approved,
            },
          }
        },
      }),

      fetchStaffList: builder.query({
        query({ page, size = 10 }) {
          return {
            url: `api/v1/bussines/team`,
            params: {
              page,
              size,
            },
          }
        },
      }),
      fetchFarmersPlot: builder.query({
        query({ id }) {
          return `${API_FARMERS_PLOTTING}?userId=${id}`
        },
      }),
      changeGrupName: builder.mutation({
        query({ name, code }) {
          return {
            url: `api/v1/bussines/group/management/${code}/update`,
            method: 'POST',
            body: {
              name,
            },
          }
        },
      }),
      deleteGroup: builder.mutation({
        query({ code }) {
          return {
            url: `api/v1/bussines/group/management/${code}`,
            method: 'DELETE',
          }
        },
      }),
      setRolePMB: builder.mutation({
        query({ userId, role }) {
          return {
            url: `api/v1/bussines/team/${userId}/set-role`,
            method: 'POST',
            body: {
              rolesId: role,
            },
          }
        },
      }),
      setRoleFarmers: builder.mutation({
        query({ userId, role }) {
          return {
            url: `api/v1/bussines/group/register-farmer/${userId}/set-role`,
            method: 'POST',
            body: {
              rolesId: role,
            },
          }
        },
      }),
      fetchUserVessel: builder.query({
        query({ id }) {
          return `${API_USER_DETAIL_VESSEL}?userId=${id}`
        },
      }),
      fetchUserCatches: builder.query({
        query({ id, page = 1, size = 10 }) {
          return {
            url: API_CATCHES,
            params: {
              userId: id,
              page,
              size,
            },
          }
        },
      }),
      inviteAgent: builder.mutation({
        query({ sellerUserId, agentUserId, isDefault }) {
          return {
            url: 'api/v1/bussines/group/invite-agent',
            method: 'POST',
            body: {
              sellerUserId,
              agentUserId,
              isDefault,
            },
          }
        },
      }),
      setDefaultAgent: builder.mutation({
        query({ id, sellerUserId }) {
          return {
            url: 'api/v1/bussines/group/set-default-agent',
            method: 'POST',
            body: {
              id,
              sellerUserId,
            },
          }
        },
      }),
      deleteAgent: builder.mutation({
        query({ id }) {
          return {
            url: `api/v1/bussines/group/invite-agent/${id}`,
            method: 'DELETE',
          }
        },
      }),
      generateGeeData: builder.mutation({
        query(data) {
          return {
            url: `api/v1/bussines/group/generate-gee-data`,
            method: 'POST',
            body: data,
          }
        },
      }),
      fetchTransferTargets: builder.query({
        query({
          userId,
          searchTerm,
          sortdir = 'ASC',
          sortby = 'name',
          page = 0,
          size = 10,
        }) {
          return {
            url: `api/v1/bussines/management/transfer/${userId}/to`,
            params: {
              search: searchTerm,
              sortdir,
              sortby,
              page,
              size,
            },
          }
        },
      }),
      transferStaff: builder.mutation({
        query({ userId, fromGroupCode, toGroupCode }) {
          return {
            url: `api/v1/bussines/management/transfer`,
            method: 'POST',
            body: {
              userId,
              fromGroupCode,
              toGroupCode,
            },
          }
        },
      }),
      fetchSummaryFarmer: builder.query({
        query(params) {
          return {
            url: API_SUMMARY_FARMERS,
            params: {
              ...params,
            },
          }
        },
      }),
      deleteStaff: builder.mutation({
        query(payload) {
          return {
            url: API_DELETE_FARMERS,
            method: 'DELETE',
            body: payload,
          }
        },
      }),
    }
  },
})

export const {
  useFetchFarmersQuery,
  useFetchFarmersV2Query,
  useLazyFetchFarmersV2Query,
  useLazyFetchFarmersQuery,
  useLazyFetchFarmersDetailQuery,
  useFetchFarmersDetailQuery,
  useLazyGetInviteAgentQuery,
  useGetInviteAgentQuery,
  useConfirmInviteAgentMutation,
  useFetchFarmersPlotQuery,
  useChangeGrupNameMutation,
  useDeleteGroupMutation,
  useFetchStaffListQuery,
  useSetRoleFarmersMutation,
  useSetRolePMBMutation,
  useFetchUserVesselQuery,
  useFetchUserCatchesQuery,
  useInviteAgentMutation,
  useSetDefaultAgentMutation,
  useDeleteAgentMutation,
  useGenerateGeeDataMutation,
  useLazyFetchTransferTargetsQuery,
  useFetchTransferTargetsQuery,
  useTransferStaffMutation,
  useFetchSummaryFarmerQuery,
  useDeleteStaffMutation
} = farmersListApiSlice
